
import {Component, Prop, Vue} from "vue-property-decorator";
import OkDialog from "@/components/common/OkDialog.vue";
import {translate} from "@/auxillary/translation";
import ReadonlyDataField from "@/models/ReadonlyDataField";

@Component({
  name: 'DecimalFieldReadonly',
  components: {
    OkDialog,
  },
})
export default class DecimalFieldReadonly extends Vue {

  @Prop({required: true})
  private dataField: ReadonlyDataField

  errorMessage: string = "";

  get labelField() {
    return this.displayName.length <= 9 ? this.displayName : ""
  }

  get labelAbove() {
    return this.displayName.length > 9 ? this.displayName : ""
  }

  get displayName() {
    if (!this.dataField.displayName) return ""
    return this.dataField.displayName;
  }

  get isVisible() {
    return this.field.isVisible;
  }

  get isReadonly() {
    return true;
  }

  get value() {
    this.validateInput()
    const value = this.dataField.values.value;
    return (value === "unknown") ? "" : value
  }

  get canBeUnknown() {
    return this.field.definition.canBeUnknown ?? false;
  }

  get unknown() {
    return this.dataField.values.unknown
  }

  get field() {
    return this.dataField;
  }

  get width() {
    // TODO needs better dynnamic width
    return 100 + (Math.max(this.suffix.length - 5, 0) * 5);
  }

  get suffix() {
    return translate(this.field.definition.unit, "unit") ?? "";
  }

  get minValue() {
    return this.field.definition.min;
  }

  get maxValue() {
    return this.field.definition.max;
  }

  get decimalSeparator() {
    return this.field.definition.decimalSeparator || ',';
  }

  validateKeyPress(evt: KeyboardEvent) {
    let keysAllowed: string[] = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
    const keyPressed: string = evt.key;

    const value = this.dataField.values?.value;
    if (!value || (value && this.decimalSeparator && value.indexOf(this.decimalSeparator) == -1)) {
      keysAllowed.push(this.decimalSeparator)
    }

    if (!keysAllowed.includes(keyPressed)) {
      evt.preventDefault()
    }
  }

  validateInput() {
    const value = this.dataField.values?.value;
    if (value) {
      const intValue = Number.parseFloat(value.replace(",", "."));
      if (this.minValue) {
        if (intValue < this.minValue) {
          this.errorMessage = "Minimalwert: " + this.minValue;
          return;
        }
      }
      if (this.maxValue) {
        if (intValue > this.maxValue) {
          this.errorMessage = "Maximalwert: " + this.maxValue;
          return;
        }
      }
    }
    this.errorMessage = "";
  }
}
